'use strict';

var focusHelper = require('base/components/focus');

var MODAL_SELECTOR = '#shippingAddressValidationModal';
var EDIT_MODAL_SELECTORS = '#editShippingAddressModal, #editBillingAddressModal';
var TRIGGER_SELECTORS = [
    '.next-step-button button',
    '#save-address',
    '.update-shipping-address',
    '#checkout-submit-payment',
    '.update-billing-address',
    '.btn-enter-multi-ship'
].join(', ');
var ariaHiddenElements = [];
var modalTrigger = null;
var suppressTriggerFocus = false;
var initialized = false;

/**
 * Read localized modal labels from page data attributes.
 * @returns {Object} modal title and close button text
 */
function getModalLabels() {
    var $labels = $('.address-validation-modal-labels').first();
    if ($labels.length) {
        return {
            title: $labels.data('modal-title') || '',
            closeText: $labels.data('close-text') || ''
        };
    }

    var $smarty = $('.enableSmartyStreetsAutoComplete').first();
    return {
        title: $smarty.data('address-modal-title') || 'Verify your address',
        closeText: $smarty.data('address-modal-close') || 'Close'
    };
}

/**
 * Build modal markup with accessibility attributes.
 * @param {Object} labels - modal title and close button text
 * @returns {string} modal HTML
 */
function buildModalHtml(labels) {
    return ''
        + '<div data-private="lipsum" class="modal fade" id="shippingAddressValidationModal" tabindex="-1"'
        + ' role="dialog" aria-modal="true"'
        + ' aria-labelledby="shippingAddressValidationModalTitle">'
        + '<div class="modal-dialog modal--added-by-js">'
        + '<div class="modal-content">'
        + '<div class="modal-header">'
        + '<h4 class="modal-title--bigger text-center" id="shippingAddressValidationModalTitle">' + labels.title + '</h4>'
        + '<button type="button" class="close pull-right" data-dismiss="modal">'
        + '<span class="sr-only">' + labels.closeText + '</span>'
        + '</button>'
        + '</div>'
        + '<div id="addressValidationStatus" class="sr-only" role="status" aria-live="polite" aria-atomic="true"></div>'
        + '<div class="modal-body"></div>'
        + '</div>'
        + '</div>'
        + '</div>';
}

/**
 * Returns the selector for the visible confirm button in the modal.
 * @returns {string} CSS selector
 */
function getLastFocusableSelector() {
    if ($('.not-found-address-button:not(.d-none)').length) {
        return '.not-found-address-button .selectedAdress';
    }

    return '.found-address-button .selectedAdress';
}

/**
 * Generates the modal window on the first call.
 * @param {Object} [options] - optional modal title and close button text from server
 */
function getModalHtmlElement(options) {
    var modalOptions = options || {};

    if ($(MODAL_SELECTOR).length !== 0) {
        var $existingModal = $(MODAL_SELECTOR);
        if ($existingModal.data('bs.modal')) {
            $existingModal.modal('dispose');
        }
        $existingModal.remove();
    }

    var labels = getModalLabels();
    if (modalOptions.modalTitle) {
        labels.title = modalOptions.modalTitle;
    }
    if (modalOptions.closeButtonText) {
        labels.closeText = modalOptions.closeButtonText;
    }

    $('body').append(buildModalHtml(labels));
}

/**
 * Update modal title and close button text after AJAX load.
 * @param {Object} options - modal title and close button text
 */
function updateModalLabels(options) {
    var $modal = $(MODAL_SELECTOR);

    if (options.modalTitle) {
        $modal.find('#shippingAddressValidationModalTitle').text(options.modalTitle);
    }
    if (options.closeButtonText) {
        $modal.find('.close .sr-only').text(options.closeButtonText);
    }
}

/**
 * Announce the visible description once via live region (avoids dialog aria-describedby duplicates).
 * @param {jQuery} $modal - verification modal
 */
function announceDescriptionOnce($modal) {
    var $status = $modal.find('#addressValidationStatus');
    var description = $.trim($modal.find('#addressSuggestionDescription').text() || '');
    if (!$status.length || !description) {
        return;
    }

    $status.empty();
    window.setTimeout(function () {
        $status.text(description);
    }, 50);
}

/**
 * Show the address suggestion modal with rendered template content.
 * @param {Object} data - AJAX response with renderedTemplate and labels
 * @returns {jQuery} modal element
 */
function showModal(data) {
    getModalHtmlElement({
        modalTitle: data.modalTitle,
        closeButtonText: data.closeButtonText
    });
    var $modal = $(MODAL_SELECTOR);
    $modal.find('.modal-body').empty().html(data.renderedTemplate);
    updateModalLabels({
        modalTitle: data.modalTitle,
        closeButtonText: data.closeButtonText
    });
    $modal.modal({ backdrop: true, keyboard: true, show: true });
    return $modal;
}

/**
 * Close any open edit-address modal, then show verification (avoids stacked Bootstrap modals).
 * @param {Object} data - AJAX response with renderedTemplate and labels
 * @returns {jQuery.Promise} resolves with the verification modal jQuery object
 */
function showModalAfterEditModals(data) {
    var deferred = $.Deferred(); // eslint-disable-line
    var $openEditModal = $(EDIT_MODAL_SELECTORS).filter('.show').first();

    if (!$openEditModal.length) {
        deferred.resolve(showModal(data));
        return deferred.promise();
    }

    $openEditModal.one('hidden.bs.modal', function () {
        deferred.resolve(showModal(data));
    });
    $openEditModal.modal('hide');
    return deferred.promise();
}

/**
 * Returns whether an element is a valid focus-restore target.
 * @param {HTMLElement} element - candidate trigger element
 * @returns {boolean} whether element can be stored as trigger
 */
function isValidTrigger(element) {
    return Boolean(
        element
        && element !== document.body
        && element !== document.documentElement
        && (element.focus || element instanceof HTMLElement)
    );
}

/**
 * Remember the element that opened the modal for focus restoration.
 * @param {HTMLElement|Object} element - trigger element
 */
function setModalTrigger(element) {
    if (isValidTrigger(element)) {
        modalTrigger = element;
    }
}

/**
 * Skip restoring focus to the trigger when the modal closes (e.g. checkout advancing to payment).
 */
function suppressTriggerFocusOnHide() {
    suppressTriggerFocus = true;
}

/**
 * Restore keyboard focus to the element that opened the modal.
 * Deferred so checkout can re-enable a disabled submit button first.
 */
function restoreFocusToTrigger() {
    if (!modalTrigger || suppressTriggerFocus) {
        modalTrigger = null;
        suppressTriggerFocus = false;
        return;
    }

    var trigger = modalTrigger;
    modalTrigger = null;
    suppressTriggerFocus = false;

    window.setTimeout(function () {
        var $trigger = $(trigger);
        if (!$trigger.length || !$trigger.is(':visible')) {
            return;
        }

        if ($trigger.is(':disabled')) {
            $trigger.prop('disabled', false);
        }

        trigger.focus();
    }, 150);
}

/**
 * Register focus trap and aria-hidden handling for the validation modal.
 */
function initAccessibility() {
    if (initialized) {
        return;
    }
    initialized = true;

    // Capture trigger on mousedown — before checkout disables the submit button and focus moves to body.
    $('body').on('mousedown.addressValidationTrigger', TRIGGER_SELECTORS, function () {
        modalTrigger = this;
    });

    $('body').on('shown.bs.modal', MODAL_SELECTOR, function () {
        var $modal = $(MODAL_SELECTOR);

        ariaHiddenElements = [];
        $('body').children().each(function () {
            var $el = $(this);
            if ($el.is($modal) || $el.hasClass('modal-backdrop')) {
                return;
            }
            if ($el.attr('aria-hidden') !== 'true') {
                ariaHiddenElements.push($el);
                $el.attr('aria-hidden', 'true');
            }
        });

        // Do not use aria-describedby on the dialog — it re-announces with focus and
        // fails when paired with aria-hidden. Announce once via live region instead.
        $modal.removeAttr('aria-describedby');
        announceDescriptionOnce($modal);

        var $firstRadio = $modal.find('input[name=verifyaddress]:first');
        var $close = $modal.find('.close');

        // Land on Close first so dialog open + radio focus do not both re-speak the dialog.
        if ($close.length) {
            $close.focus();
        }

        window.setTimeout(function () {
            if ($firstRadio.length) {
                $firstRadio.focus();
            }
        }, 200);
    });

    $('body').on('hidden.bs.modal', MODAL_SELECTOR, function () {
        var $modal = $(MODAL_SELECTOR);
        $modal.find('#addressValidationStatus').empty();

        ariaHiddenElements.forEach(function ($el) {
            $el.attr('aria-hidden', 'false');
        });
        ariaHiddenElements = [];

        restoreFocusToTrigger();
    });

    $('body').on('keydown', MODAL_SELECTOR, function (e) {
        var focusParams = {
            event: e,
            containerSelector: MODAL_SELECTOR,
            firstElementSelector: '.close',
            lastElementSelector: getLastFocusableSelector(),
            nextToLastElementSelector: 'input[name=verifyaddress]:last'
        };
        focusHelper.setTabNextFocus(focusParams);
    });
}

module.exports = {
    MODAL_SELECTOR: MODAL_SELECTOR,
    getModalHtmlElement: getModalHtmlElement,
    showModal: showModal,
    showModalAfterEditModals: showModalAfterEditModals,
    updateModalLabels: updateModalLabels,
    setModalTrigger: setModalTrigger,
    suppressTriggerFocusOnHide: suppressTriggerFocusOnHide,
    initAccessibility: initAccessibility
};
